import { create } from 'zustand';

interface StoreState {
  page: string | null;
  setPage: (page: string) => void;
  showSocialButtons: boolean;
  setShowSocialButtons: () => void;
  generatingPDF: boolean;
  setGeneratingPDF: (generatingPDF: boolean) => void;
}

const useStore = create<StoreState>((set) => ({
  page: 'introduction',
  setPage: (page) => set({ page }),
  showSocialButtons: false,
  setShowSocialButtons: () =>
    set((state) => ({ showSocialButtons: !state.showSocialButtons })),
  generatingPDF: false,
  setGeneratingPDF: (generatingPDF) => set(() => ({ generatingPDF })),
}));

export default useStore;
